/**
 * Test it's "Show it as" (P-2.10): how the options under a reply look on the chosen channel,
 * and what a tap sends back. Pure.
 *
 * The STYLE comes from the server (`reply.choices.style`, `renderChoices` in the sidecar, the
 * same function the reply path sends through); this file only turns it into what the thread
 * draws. It never guesses a style of its own.
 */
import { TASK_CHANNELS } from './task-channels.js';

/** The channels Test it can pretend to be, WhatsApp first (the default). */
export const TEST_CHANNELS = TASK_CHANNELS;
export const DEFAULT_TEST_CHANNEL = 'whatsapp';

/** WhatsApp shows at most this many reply buttons; more go behind one list button. */
export const MAX_REPLY_BUTTONS = 3;

/**
 * How the thread draws `choices`:
 *  - `buttons`: WhatsApp reply buttons (up to three);
 *  - `list`: a WhatsApp list, four to ten rows behind `listButton`;
 *  - `chips`: Instagram, Messenger and Telegram;
 *  - `none`: a numbered list, already in the reply's text (a website chat, email, SMS).
 */
export const choiceLayout = choices => {
  if (!choices || !Array.isArray(choices.items) || choices.items.length === 0) {
    return { kind: 'none', items: [], listButton: null };
  }
  const { style, items, listButton } = choices;
  if (style === 'whatsapp') {
    return items.length <= MAX_REPLY_BUTTONS
      ? { kind: 'buttons', items, listButton: null }
      : { kind: 'list', items, listButton };
  }
  if (
    style === 'instagram' ||
    style === 'quick_replies' ||
    style === 'inline_keyboard'
  ) {
    return { kind: 'chips', items, listButton: null };
  }
  return { kind: 'none', items: [], listButton: null };
};

/**
 * What a tap sends. WhatsApp and Instagram carry the tap's id back (`submitted_values`), so the
 * rehearsal sends `{ id, title }`; Messenger and Telegram hand back only the words, which reach
 * the reply path as a typed message, so the rehearsal sends the title and no choice (docs §8).
 */
export const tapSendsChoice = style =>
  style === 'whatsapp' || style === 'instagram';
